export const BASE_URL = import.meta.env.VITE_APP_ME_QR_URL;
